import React, { useState } from "react";
import accessURL from "../../../../components/utils/superAccess";

// Toast component to show custom messages
const Toast: React.FC<{ message: string; type: "success" | "error" }> = ({
  message,
  type,
}) => {
  return (
    <div
      className={`fixed bottom-4 left-1/2 transform -translate-x-1/2 mb-4 p-4 rounded-md text-white ${
        type === "success" ? "bg-green-500" : "bg-red-500"
      } shadow-lg transition-all duration-300`}
    >
      {message}
    </div>
  );
};

const Expire: React.FC<{ id: number }> = ({ id }) => {
  const [loading, setLoading] = useState(false);

  // Allowing 'null' initially, and then 'success' or 'error' once the toast is triggered.
  const [toast, setToast] = useState<{
    message: string;
    type: "success" | "error";
  } | null>(null);

  const handleExpire = async () => {
    // Confirm if the user is sure about expiring
    const isConfirmed = window.confirm(
      "Are you sure you want to suspend user."
    );

    if (isConfirmed) {
      setLoading(true); // Show loading state
      try {
        // Make the API request to expire the payment
        const res = await accessURL.post("payments/expire", { id });

        // Check if the response is successful
        if (res.data.code === 200) {
          setToast({
            message: "User suspend successfully!",
            type: "success",
          });
          setTimeout(() => window.location.reload(), 2000); // Refresh the page after 2 seconds
        } else {
          setToast({
            message: "Failed to suspend user.",
            type: "error",
          });
        }
      } catch (error) {
        setToast({
          message: "An error occurred. Please try again later.",
          type: "error",
        });
      } finally {
        setLoading(false); // Hide loading state
      }
    }
  };

  return (
    <div>
      {/* Toast Notification */}
      {toast && <Toast message={toast.message} type={toast.type} />}

      <button
        onClick={handleExpire}
        disabled={loading} // Disable button when loading
        className={`${
          loading ? "bg-gray-500" : "bg-red-600"
        } text-white py-2 px-4 rounded-md font-semibold focus:outline-none focus:ring-2 focus:ring-red-500 transition duration-300 hover:bg-red-700`}
      >
        {loading ? "Processing..." : "Suspend User"}
      </button>
    </div>
  );
};

export default Expire;
